import { GlobalAction } from '../../interfaces/GlobalAction';
import { NewMessagePageState } from '../../interfaces/NewMessagePageState';
import { Subject } from '../../interfaces/Subject';
import { CHANGE_CONTRACT, CHANGE_BUSINESS_LINE, CHANGE_SUBJECT_GROUP } from './NewMessagePage.actions';

const newMessagePageReducer = (state: NewMessagePageState, action: GlobalAction): NewMessagePageState => {
  switch (action.type) {
    case CHANGE_CONTRACT:
      return changeContract(state);
    case CHANGE_BUSINESS_LINE:
      return changeBusinessLine(state);
    case CHANGE_SUBJECT_GROUP:
      return changeSubjectGroup(state);
    default:
      return state;
  }
};

const changeContract = (state: NewMessagePageState): NewMessagePageState => ({
  ...state,

  mailFormValues: {
    ...state.mailFormValues,
    ...(state.mailFormValues.subjectGroup ? { subjectGroup: '' } : {}),
    ...(state.mailFormValues.subject ? { subject: {} as Subject } : {}),
    ...(state.mailFormValues.subjectAssignment ? { subjectAssignment: '' as string } : {}),
    ...(state.mailFormValues.specify ? { specify: '' } : {}),
  },
  subjectAssignments: [],
});
const changeBusinessLine = (state: NewMessagePageState): NewMessagePageState => ({
  ...state,
  mailFormValues: {
    ...state.mailFormValues,
    ...(state.mailFormValues.subjectGroup ? { subjectGroup: '' } : {}),
    ...(state.mailFormValues.subject ? { subject: {} as Subject } : {}),
    ...(state.mailFormValues.specify ? { specify: '' } : {}),
    ...(state.mailFormValues.subjectAssignment ? { subjectAssignment: '' as string } : {}),
    ...(state.mailFormValues.contractText ? { contractText: '' } : {}),
  },
  subjectAssignments: [],
});
const changeSubjectGroup = (state: NewMessagePageState): NewMessagePageState => ({
  ...state,
  mailFormValues: {
    ...state.mailFormValues,
    ...(state.mailFormValues.subject ? { subject: {} as Subject } : {}),
    ...(state.mailFormValues.specify ? { specify: '' } : {}),
    ...(state.mailFormValues.subjectAssignment ? { subjectAssignment: '' as string } : {}),
  },
  subjectAssignments: [],
});
export default newMessagePageReducer;
